import React from 'react';

const TabNavigation = ({ activeTab, setActiveTab, playerDragons, maxDragons }) => {
  const tabs = [
    { id: 'inventory', label: `My Dragons`, count: `(${playerDragons.length}/${maxDragons})`, icon: '🐉', color: 'orange' },
    { id: 'shop', label: 'Shop', icon: '💰', color: 'green' },
    { id: 'breeding', label: 'Breeding', icon: '🧬', color: 'purple' },
    { id: 'encyclopedia', label: 'Tome', icon: '📖', color: 'blue' },
    { id: 'battle', label: 'Battle', icon: '⚔️', color: 'red' },
    { id: 'index', label: 'Index', icon: '📜', color: 'yellow' }
  ];

  const colorClasses = {
    orange: { active: 'bg-orange-500/20 border-orange-400 text-orange-300', inactive: 'border-transparent hover:bg-white/5' },
    green: { active: 'bg-green-500/20 border-green-400 text-green-300', inactive: 'border-transparent hover:bg-white/5' },
    purple: { active: 'bg-purple-500/20 border-purple-400 text-purple-300', inactive: 'border-transparent hover:bg-white/5' },
    blue: { active: 'bg-blue-500/20 border-blue-400 text-blue-300', inactive: 'border-transparent hover:bg-white/5' },
    red: { active: 'bg-red-500/20 border-red-400 text-red-300', inactive: 'border-transparent hover:bg-white/5' },
    yellow: { active: 'bg-yellow-500/20 border-yellow-400 text-yellow-300', inactive: 'border-transparent hover:bg-white/5' },
  }

  return (
    <div className="flex mb-4 space-x-2 flex-shrink-0">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const colors = colorClasses[tab.color];

        return (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex-1 py-3 px-2 rounded-lg transition-all duration-300 flex flex-col items-center justify-center text-xs font-semibold border-b-2 ${isActive ? colors.active : colors.inactive + ' text-gray-400'}`}
          >
            <span className="text-2xl mb-1">{tab.icon}</span>
            <span className="font-mono tracking-widest uppercase">{tab.label}</span>
            {tab.count && <span className="text-xs font-sans normal-case opacity-70">{tab.count}</span>}
          </button>
        )
      })}
    </div>
  );
};

export default TabNavigation;
